import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import MailIcon from '@mui/icons-material/Mail';
import SettingsIcon from '@mui/icons-material/Settings';
import { AppBar, Badge, Box, Button, IconButton, Stack, Toolbar, Tooltip, Typography } from '@mui/material';
import { createTheme, styled, useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDesktop } from 'src/contexts/DesktopProvider';
import useCollapseDrawer from 'src/hooks/useCollapseDrawer';
import { NavConfig } from 'src/navConfig';
import HttpServices from 'src/services/httpService';
import { integrateModuleURL, userModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useReAuth } from 'src/utils/reAuth/ReAuthContext';
import { useToaster } from 'src/utils/toaster/toasterContext';
import AccountPopover from './AccountPopover';
import InactiveProfiles from './inActiveConnectedProfiles.component';
import NotificationsPopover from './NotificationsPopover';
import ReferAndEarnPopup from 'src/components/ReferAndEarnPopup';
import TrialPlanDetailsPopup from 'src/trailPlanDetailsPopup';
import FeedbackPopup from 'src/components/FeedbackPopup';
import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputBase from '@mui/material/InputBase';
import useMediaQuery from '@mui/material/useMediaQuery';
import RenewPlanWarning from 'src/components/RenewPlanWarning';
import PreviousPaidPlanWarning from 'src/components/PreviousPaidPlanWarning';
import { LoadLanguage } from 'src/components/languageService';

export default function Header({ headerName, isShowOfferBanner = false }) {
  const selectedLanguage = localStorage.getItem('i18nextLng') || 'english';
  const { t: translate, i18n } = useTranslation();
  const { isCollapse } = useCollapseDrawer();
  const isLargeScreen = useMediaQuery('(min-width:1550px)');

  const navigate = useNavigate();
  const isDesktop = useDesktop();
  const theme = useTheme();
  const { showToast } = useToaster();
  const { checkAndTriggerReAuth } = useReAuth();

  const isOrgUser = CommonHelper.GetBrandInfoFromLocalStorage('is_org_user');
  const isReferralUser = CommonHelper.GetBrandInfoFromLocalStorage('is_referral_user');
  const isIntegSocial = CommonHelper.IsIntegSocialDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage('is_portal_admin');
  const userOrgDetails = CommonHelper.GetBrandInfoFromLocalStorage();
  const brandDetails = CommonHelper.GetBrandInfoFromLocalStorage('brand_details');
  const isCustomDomain = CommonHelper.CustomDomain();
  const currentPlanInfo = CommonHelper.GetBrandInfoFromLocalStorage('current_plan_info');
  const [showRenewWarning, setShowRenewWarning] = useState(CommonHelper.CheckIsRenewPlanWarning(currentPlanInfo));
  const [showPreviousPaidPlanWarning, setShowPreviousPaidPlanWarning] = useState(
    CommonHelper.CheckIsPreviousPaidPlanWarning(currentPlanInfo)
  );
  const freePlan = 'free_plan';
  const previousPaidPlan = currentPlanInfo?.previous_paid_plan_details;

  // State variable
  const [isVerified, setisVerified] = useState(true);
  const [isPlanExpired, setPlanExpired] = useState(false);
  const [isReferPopupOpen, setIsReferPopupOpen] = useState(false);
  const [isReferLoading, setIsReferLoading] = useState(false);
  const [showPlanDetailsPopup, setShowPlanDetailsPopup] = useState(false);
  const [isFeedbackPopupOpen, setIsFeedbackPopupOpen] = useState(false);
  const [isFeedbackLoading, setIsFeedbackLoading] = useState(false);
  const [language, setLanguage] = useState(selectedLanguage);

  useEffect(() => {
    getUserInfo();
    if (brandDetails && brandDetails?.length > 0) {
      checkAndTriggerReAuth();
    }
    if (window.Tawk_API) {
      window.Tawk_API.onLoad = function () {
        window.Tawk_API.hideWidget();
      };
    }
  }, []);
  const getUserInfo = () => {
    let isVerified = CommonHelper.GetUserIsVerified();
    let planDetails = CommonHelper.GetCurrentFromLocalStorage();
    setisVerified(isVerified);
    if (planDetails) {
      if (planDetails.plan_id === freePlan || planDetails.expire_in_days === 0) setPlanExpired(true);
    }
  };
  const navigateToPayment = () => {
    navigate('/billing');
  };
  const failureCallback = (message) => {
    message && showToast(message, 'e');
  };
  const successCallback = (data, message) => {
    message && showToast(message, 's');
  };
  const resendEmail = () => {
    let postProps = {
      url: userModuleURL.resendVerificationMail,
      successCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
  };

  const handleOpenSettings = () => {
    navigate('/profile');
  };

const handleOpenChatBot = () => {
  if (window.Tawk_API) {
    if (window.Tawk_API.isChatHidden()) {
      window.Tawk_API.showWidget();
      window.Tawk_API.maximize();
    } else {
      window.Tawk_API.hideWidget();
    }
  }
};
  const handleOpenReferPopup = () => {
    setIsReferPopupOpen(true);
  };
  const handleCloseReferPopup = () => {
    setIsReferPopupOpen(false);
  };
  const referSuccessCallback = (data, message) => {
    showToast(message, 's');
    setIsReferLoading(false);
    setIsReferPopupOpen(false);
    navigate('/refer-earn', { state: 'reload' });
  };
  const referFailureCallback = (message) => {
    showToast(message, 'e');
    setIsReferLoading(false);
  };
  const handleReferConfirm = () => {
    setIsReferLoading(true);
    let postProps = {
      url: integrateModuleURL.addUserAffiliate,
      successCallback: referSuccessCallback,
      failureCallback: referFailureCallback,
      body: { subject: 'Refer and Earn', message: 'I want to refer and earn. Orgid - ' + userOrgDetails.org_id },
    };
    HttpServices.Post(postProps);
  };

  const closePopup = () => {
    setShowPlanDetailsPopup(false);
  };

  const handleOpenFeedbackPopup = () => {
    setIsFeedbackPopupOpen(true);
  };
  const handleCloseFeedbackPopup = () => {
    setIsFeedbackPopupOpen(false);
  };
  const feedbackSuccessCallback = () => {
    showToast('Thank you for your feedback!', 's');
    setIsFeedbackLoading(false);
    setIsFeedbackPopupOpen(false);
  };
  const handleFeedbackSubmit = ({ rating, feedback }) => {
    setIsFeedbackLoading(true);
    setIsReferLoading(true);
    let postProps = {
      url: integrateModuleURL.handleContactUs,
      successCallback: feedbackSuccessCallback,
      failureCallback: referFailureCallback,
      body: {
        subject: 'Write a review',
        message: `Rating - ${rating}. Feedback - ${feedback}. Orgid - ${userOrgDetails.org_id}`,
      },
    };
    HttpServices.Post(postProps);
  };

  const isShowStartTrialButton = () => {
    if (
      isOrgUser &&
      isPortalAdmin &&
      currentPlanInfo?.has_subscription &&
      currentPlanInfo?.has_trail_plan &&
      currentPlanInfo?.has_trial_period &&
      !currentPlanInfo.is_appsumo_user
    ) {
      return true;
    } else {
      return false;
    }
  };

  //Styled Components
  const HEADER_MOBILE = 64;

  const customTheme = createTheme({
    breakpoints: {
      values: {
        mdCustom: 1100,
        mdCustom0: 1250,
      },
    },
  });

  const StyledRoot = styled(AppBar)(({ theme }) => ({
    ...(isShowOfferBanner && {
      marginTop: '3.2rem',
    }),
    backgroundColor: theme.palette.background.default,
    boxShadow: 'none',
    [customTheme.breakpoints.up('mdCustom')]: {
      width: '100%',
      ...(headerName !== '' && {
        width: `calc(100% - ${NavConfig.NAVBAR.DASHBOARD_WIDTH + 70}px)`,
        ...(isCollapse && {
          width: `calc(100% - ${NavConfig.NAVBAR.DASHBOARD_COLLAPSE_WIDTH + 72}px)`,
        }),
      }),
      height: '64px',
      zIndex: '1101',
      backdropFilter: 'blur(6px)',
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      transition: 'height 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      borderBottom: '1px solid ' + theme.palette.primary.main,
      borderBottomStyle: 'dashed',
    },
  }));
  const handleHelperTextClick = () => {
    navigate('/manage-brand');
  };
  const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    minHeight: HEADER_MOBILE,
    [customTheme.breakpoints.up('mdCustom')]: {
      padding: theme.spacing(0, 2.5),
    },
  }));

  const handleLanguageChange = async (event) => {
    const lang = event.target.value;
    setLanguage(lang);
    localStorage.setItem('i18nextLng', lang);

    try {
      await LoadLanguage(lang);
      window.location.reload();
    } catch (error) {
      showToast('Failed to load language', 'e');
    }
  };

  return (
    <>
      {isShowOfferBanner && (
        <Box
          sx={{
            background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
            padding: '0.5rem 1rem',
            textAlign: 'center',
            borderBottom: '3px solid #ff6b00',
            boxShadow: '0 4px 12px rgba(255, 107, 0, 0.2)',
            cursor: 'pointer',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: '#fff',
              fontWeight: 700,
              fontSize: '1rem',
              letterSpacing: 1,
              mb: 0.5,
            }}
            onClick={() => {
              navigate('/billing');
            }}
          >
            🎉 Summer SPECIAL OFFER 🎉 Pay for 8 Months • Get 1 Year Subscription
          </Typography>
        </Box>
      )}
      <StyledRoot>
        <StyledToolbar>
          <Typography
            sx={{
              color: 'black',
              fontWeight: 700,
              fontSize: '20px',
            }}
          >
            {headerName}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Stack
            direction="row"
            alignItems="center"
            spacing={{
              xs: 0.5,
              sm: 1,
            }}
          >
            {headerName && (
              <>
                {isPlanExpired && (
                  <Button
                    size="small"
                    sx={{ background: theme.palette.primary.main }}
                    variant="contained"
                    onClick={navigateToPayment}
                  >
                    <Badge variant="dot" sx={{ mr: 1 }}>
                      <MailIcon />
                    </Badge>
                    {translate('integration.upgrade_to_pro')}
                  </Button>
                )}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <InactiveProfiles isLargeScreen={isLargeScreen} />
                </Box>
                {!isVerified && isDesktop && (
                  <Tooltip title={!isLargeScreen ? translate('header.verify_email') : ''} arrow placement="bottom">
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#ffebee',
                        p: 1,
                        px: isLargeScreen ? 2 : 1,
                        borderRadius: 2,
                        gap: 1,
                      }}
                    >
                      <MailIcon color="error" sx={{ fontSize: 20 }} />
                      {isLargeScreen && (
                        <Typography variant="body2" color="error">
                          {translate('header.verify_email')}
                          <Tooltip title={translate('header.send_new_verification_email')} arrow>
                            <Typography
                              component="span"
                              color="error"
                              sx={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 'medium', ml: 0.5 }}
                              onClick={resendEmail}
                            >
                              {translate('header.resend_email')}
                            </Typography>
                          </Tooltip>
                        </Typography>
                      )}
                    </Box>
                  </Tooltip>
                )}

                {!isIntegSocial && isOrgUser && !isReferralUser && isPortalAdmin && isVerified && (
                  <Tooltip title={!isLargeScreen ? 'Refer and Earn' : ''} arrow placement="bottom">
                    <Button
                      size="small"
                      variant="contained"
                      onClick={handleOpenReferPopup}
                      disableElevation
                      sx={{
                        ml: 1,
                        fontWeight: 600,
                        background: 'linear-gradient(90deg, #ff9800 0%, #ffc107 100%)',
                        color: '#fff',
                        boxShadow: '0 2px 8px 0 rgba(255, 193, 7, 0.15)',
                        borderRadius: 2,
                        textTransform: 'none',
                        '&:hover': {
                          background: 'linear-gradient(90deg, #ffc107 0%, #ff9800 100%)',
                          color: '#fff',
                          boxShadow: '0 4px 16px 0 rgba(255, 193, 7, 0.25)',
                        },
                        px: isLargeScreen ? 2.5 : 1.5,
                        py: 1,
                        minWidth: isLargeScreen ? 'auto' : 40,
                        height: 40,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: isLargeScreen ? 1 : 0,
                      }}
                    >
                      <CardGiftcardIcon sx={{ fontSize: '1.2rem', color: '#fff' }} />
                      {isLargeScreen && (
                        <Typography variant="button" sx={{ fontSize: '15px', letterSpacing: 0.2 }}>
                          Refer and Earn
                        </Typography>
                      )}
                    </Button>
                  </Tooltip>
                )}
                {isOrgUser && isPortalAdmin && isVerified && (
                  <Tooltip title={!isLargeScreen ? 'Feedback' : ''} arrow placement="bottom">
                    <Button
                      size="small"
                      variant="contained"
                      color="info"
                      onClick={handleOpenFeedbackPopup}
                      disableElevation
                      sx={{
                        ml: 1,
                        fontWeight: 600,
                        background: 'linear-gradient(90deg, #607d8b 0%, #90a4ae 100%)',
                        color: '#fff',
                        boxShadow: '0 2px 8px 0 rgba(96, 125, 139, 0.15)',
                        borderRadius: 2,
                        textTransform: 'none',
                        '&:hover': {
                          background: 'linear-gradient(90deg, #90a4ae 0%, #607d8b 100%)',
                          boxShadow: '0 4px 16px 0 rgba(96, 125, 139, 0.25)',
                        },
                        px: isLargeScreen ? 2.5 : 1.5,
                        py: 1,
                        minWidth: isLargeScreen ? 'auto' : 40,
                        display: 'flex',
                        alignItems: 'center',
                        gap: isLargeScreen ? 1 : 0,
                      }}
                    >
                      <HeadsetMicIcon sx={{ fontSize: '1.1rem' }} />
                      {isLargeScreen && (
                        <Typography variant="button" sx={{ fontSize: '15px', letterSpacing: 0.2 }}>
                          Feedback
                        </Typography>
                      )}
                    </Button>
                  </Tooltip>
                )}
                {isShowStartTrialButton() && (
                  <Tooltip
                    title={!isLargeScreen ? translate('billing.subscription_info.trail_plan') : ''}
                    arrow
                    placement="bottom"
                  >
                    <Button
                      size="small"
                      variant="contained"
                      onClick={() => setShowPlanDetailsPopup(true)}
                      sx={{
                        ml: 1,
                        fontWeight: 600,
                        background: 'linear-gradient(90deg, #e53935 0%, #ef5350 100%)',
                        color: '#fff',
                        boxShadow: '0 2px 8px 0 rgba(239, 83, 80, 0.25)',
                        borderRadius: 2,
                        textTransform: 'none',
                        '&:hover': {
                          background: 'linear-gradient(90deg, #ef5350 0%, #e53935 100%)',
                          boxShadow: '0 4px 12px 0 rgba(239, 83, 80, 0.4)',
                        },
                        px: isLargeScreen ? 2 : 1.5,
                        py: 0.8,
                        minWidth: isLargeScreen ? 'auto' : 48,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: isLargeScreen ? 0.8 : 0.4,
                      }}
                    >
                      <CardGiftcardIcon sx={{ fontSize: '1.3rem', color: '#ffe5e5' }} />
                      {isLargeScreen && (
                        <Box sx={{ textAlign: 'center', lineHeight: 1.2 }}>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: 700,
                              fontSize: '13px',
                              color: '#ffebee',
                              textShadow: '0 1px 1px rgba(0,0,0,0.2)',
                            }}
                          >
                            {translate('billing.subscription_info.trail_plan')}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              display: 'block',
                              fontWeight: 700,
                              fontSize: '11px',
                              color: '#ffe5e5',
                              opacity: 0.95,
                            }}
                          >
                            Exp: {CommonHelper.formatDateAndTime(currentPlanInfo?.expire_date, 'date')}
                          </Typography>
                        </Box>
                      )}
                    </Button>
                  </Tooltip>
                )}

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.82rem',
                    px: 1,
                    py: 0.5,
                    borderRadius: 1,
                    background: '#f5f7fa',
                    boxShadow: '0 1px 4px 0 rgba(33,150,243,0.04)',
                    minHeight: 32,
                    width: 'fit-content',
                    mx: 1,
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <AccessTimeIcon sx={{ fontSize: 16, color: theme.palette.primary.main, mr: 0.5 }} />
                    <Typography variant="body2" sx={{ color: '#444', fontWeight: 500, px: 0.5, textAlign: 'center' }}>
                      {translate('header.current_timezone')} {CommonHelper.GetBrandTimeZone()}
                    </Typography>
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{
                      cursor: 'pointer',
                      color: theme.palette.primary.main,
                      textDecoration: 'underline',
                      mt: 0.5,
                      fontWeight: 500,
                      textAlign: 'center',
                      width: '100%',
                      '&:hover': {
                        textDecoration: 'none',
                        color: theme.palette.primary.dark,
                      },
                    }}
                    onClick={handleHelperTextClick}
                  >
                    {translate('header.want_to_change_it')}?
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mx: 1 }}>
                  <Select
                    value={language}
                    onChange={handleLanguageChange}
                    input={<InputBase />}
                    size="small"
                    sx={{
                      fontWeight: 500,
                      fontSize: '15px',
                      background: '#f5f7fa',
                      borderRadius: 1,
                      pl: 1,
                      pr: 2,
                      height: 32,
                      minWidth: 120,
                      boxShadow: '0 1px 4px 0 rgba(33,150,243,0.04)',
                    }}
                  >
                    <MenuItem value="english">
                      <span role="img" aria-label="English" style={{ marginRight: 8 }}>
                        🇬🇧
                      </span>{' '}
                      English
                    </MenuItem>
                    <MenuItem value="tamil">
                      <span role="img" aria-label="Tamil" style={{ marginRight: 8 }}>
                        🇮🇳
                      </span>{' '}
                      Tamil
                    </MenuItem>
                    <MenuItem value="german">
                      <span role="img" aria-label="German" style={{ marginRight: 8 }}>
                        🇩🇪
                      </span>{' '}
                      German{' '}
                      <span style={{ color: '#ff9800', fontWeight: 600, marginLeft: 6, fontSize: '12px' }}>(Beta)</span>
                    </MenuItem>
                    <MenuItem value="portuguese">
                      <span role="img" aria-label="Portuguese" style={{ marginRight: 8 }}>
                        🇵🇹
                      </span>{' '}
                      Portuguese{' '}
                      <span style={{ color: '#ff9800', fontWeight: 600, marginLeft: 6, fontSize: '12px' }}>(Beta)</span>
                    </MenuItem>
                    <MenuItem value="spanish">
                      <span role="img" aria-label="Spanish" style={{ marginRight: 8 }}>
                        🇪🇸
                      </span>{' '}
                      Spanish{' '}
                      <span style={{ color: '#ff9800', fontWeight: 600, marginLeft: 6, fontSize: '12px' }}>(Beta)</span>
                    </MenuItem>
                    <MenuItem value="french">
                      <span role="img" aria-label="French" style={{ marginRight: 8 }}>
                        🇫🇷
                      </span>{' '}
                      French
                      <span style={{ color: '#ff9800', fontWeight: 600, marginLeft: 6, fontSize: '12px' }}>(Beta)</span>
                    </MenuItem>
                    <MenuItem value="norwegian">
                      <span role="img" aria-label="Norwegian" style={{ marginRight: 8 }}>
                        🇳🇴
                      </span>{' '}
                      Norwegian{' '}
                      <span style={{ color: '#ff9800', fontWeight: 600, marginLeft: 6, fontSize: '12px' }}>(Beta)</span>
                    </MenuItem>
                    <MenuItem value="arabic">
                      <span role="img" aria-label="Arabic" style={{ marginRight: 8 }}>
                        🇸🇦
                      </span>
                      Arabic
                        <span style={{ color: '#ff9800', fontWeight: 600, marginLeft: 6, fontSize: '12px' }}>(Beta)</span>
                    </MenuItem>
                  </Select>
                </Box>
                <NotificationsPopover />

                {!isCustomDomain && headerName && (
                  <IconButton onClick={handleOpenChatBot} sx={{ width: 40, height: 40 }}>
                    <HeadsetMicIcon sx={{ width: '20px', height: '20px' }} />
                  </IconButton>
                )}
                {headerName && (
                  <IconButton onClick={handleOpenSettings} sx={{ width: 40, height: 40 }}>
                    <SettingsIcon sx={{ width: '20px', height: '20px' }} />
                  </IconButton>
                )}
              </>
            )}
            <AccountPopover headerName={headerName} />
          </Stack>
          <ReferAndEarnPopup
            open={isReferPopupOpen}
            onClose={handleCloseReferPopup}
            onConfirm={handleReferConfirm}
            loading={isReferLoading}
            theme={theme}
            translate={translate}
          />
        </StyledToolbar>
      </StyledRoot>
      {showPlanDetailsPopup && <TrialPlanDetailsPopup closePopup={closePopup} />}
      {showRenewWarning && (
        <RenewPlanWarning
          open={showRenewWarning}
          currentPlanInfo={currentPlanInfo}
          onClose={() => setShowRenewWarning(false)}
          onRenew={() => {
            window.location.href = '/billing';
          }}
        />
      )}
      {showPreviousPaidPlanWarning && (
        <PreviousPaidPlanWarning
          open={showPreviousPaidPlanWarning}
          previousPaidPlan={previousPaidPlan}
          onClose={() => setShowPreviousPaidPlanWarning(false)}
        />
      )}
      <FeedbackPopup
        open={isFeedbackPopupOpen}
        onClose={handleCloseFeedbackPopup}
        onSubmit={handleFeedbackSubmit}
        loading={isFeedbackLoading}
        theme={theme}
      />
    </>
  );
}